import React, { Fragment } from 'react';
import { CheckIcon } from 'lucide-react';
interface Step {
  id: number;
  title: string;
}
interface StepIndicatorProps {
  steps: Step[];
  currentStep: number;
  onStepClick: (index: number) => void;
}
export function StepIndicator({
  steps,
  currentStep,
  onStepClick
}: StepIndicatorProps) {
  return <div className="flex flex-col h-full" data-id="element-324" data-mp="n2hksvt57902">
      {/* Vertical Steps (Desktop) */}
      <div className="hidden md:flex flex-col space-y-1 px-3 pt-6" data-id="element-325" data-mp="9c4boq4ilo95">
        {steps.map((step, index) => {
        const isCompleted = index < currentStep;
        const isActive = index === currentStep;
        const isClickable = isCompleted;
        return <button key={step.id} onClick={() => isClickable && onStepClick(index)} disabled={!isClickable && !isActive} className={`flex items-center w-full text-left px-3 py-2.5 rounded-lg transition-all relative ${isActive ? 'bg-blue-50' : isClickable ? 'hover:bg-gray-50 cursor-pointer' : 'cursor-default opacity-60'}`} data-id="element-326" data-mp="4db0j4cpa9c5" data-mpi={index}>
              {isActive && <div className="absolute left-0 top-1/2 -translate-y-1/2 w-[3px] h-6 bg-navy-600 rounded-r-full" data-id="element-327" data-mp="3szipa3mk2opu" />}

              <div className="flex-shrink-0 mr-3" data-id="element-328" data-mp="bq3ue6jz1xzw">
                {isCompleted ? <div className="w-6 h-6 rounded-full bg-[#2E844A] flex items-center justify-center" data-id="element-329" data-mp="6su82zrvq2ga">
                    <CheckIcon className="w-3.5 h-3.5 text-white" data-id="element-330" data-mp="3f842dlpj23di" />
                  </div> : isActive ? <div className="w-6 h-6 rounded-full bg-navy-600 flex items-center justify-center" data-id="element-331" data-mp="3a651qjl69kk9">
                    <span className="text-white text-xs font-bold" data-id="element-332" data-mp="3oz8kguai24ck">
                      {step.id}
                    </span>
                  </div> : <div className="w-6 h-6 rounded-full bg-gray-200 flex items-center justify-center" data-id="element-333" data-mp="2wfa09sd065qp">
                    <span className="text-gray-500 text-xs font-bold" data-id="element-334" data-mp="2rh8gf57r62e6">
                      {step.id}
                    </span>
                  </div>}
              </div>
              <span className={`text-sm font-medium ${isActive ? 'text-navy-600' : isCompleted ? 'text-gray-700' : 'text-gray-500'}`} data-id="element-335" data-mp="3l665yy6l7rpa">
                {step.title}
              </span>
            </button>;
      })}
      </div>

      {/* Horizontal Steps (Mobile) */}
      <div className="md:hidden flex items-center justify-between px-4 py-3 border-b border-gray-100 bg-white" data-id="element-336" data-mp="2y8m59880s1dv">
        {steps.map((step, index) => {
        const isCompleted = index < currentStep;
        const isActive = index === currentStep;
        const isClickable = isCompleted;
        return <Fragment key={step.id} data-id="element-337" data-mp="3c83wrvcp9sqx" data-mpi={index}>
              <button onClick={() => isClickable && onStepClick(index)} disabled={!isClickable && !isActive} className="flex flex-col items-center group relative" data-id="element-338" data-mp="mhqtn4f5k47p">
                <div className="flex-shrink-0 mb-1" data-id="element-339" data-mp="2bxksm1czuf3g">
                  {isCompleted ? <div className="w-6 h-6 rounded-full bg-[#2E844A] flex items-center justify-center" data-id="element-340" data-mp="26z9l3xa68goe">
                      <CheckIcon className="w-3.5 h-3.5 text-white" data-id="element-341" data-mp="227rjd70bqc2d" />
                    </div> : isActive ? <div className="w-6 h-6 rounded-full bg-navy-600 flex items-center justify-center ring-4 ring-navy-50" data-id="element-342" data-mp="1x9g94v649zjm">
                      <span className="text-white text-xs font-bold" data-id="element-343" data-mp="1o91jjjm4dyab">
                        {step.id}
                      </span>
                    </div> : <div className="w-6 h-6 rounded-full bg-gray-100 flex items-center justify-center" data-id="element-344" data-mp="1jc1ftfcqt7md">
                      <span className="text-gray-400 text-xs font-bold" data-id="element-345" data-mp="1ed8a493p6kwr">
                        {step.id}
                      </span>
                    </div>}
                </div>
                <span className={`text-[10px] font-medium absolute -bottom-4 whitespace-nowrap ${isActive ? 'text-navy-600' : 'text-gray-400'}`} data-id="element-346" data-mp="38n28f95oxhiv">
                  {isActive ? step.title : ''}
                </span>
              </button>
              {index < steps.length - 1 && <div className={`flex-1 h-[2px] mx-2 rounded-full ${index < currentStep ? 'bg-[#2E844A]' : 'bg-gray-100'}`} data-id="element-347" data-mp="3bq81vjc4k45x" />}
            </Fragment>;
      })}
      </div>
    </div>;
}